// jsdom 26+ makes window.location non-configurable, so tests can no longer mock it directly.
// Production code must call navigation through these wrappers so tests can mock this module instead.

export const setLocationHref = (url: string): void => {
  window.location.href = url;
};

export const replaceLocation = (url: string): void => {
  window.location.replace(url);
};

export const reloadPage = (): void => {
  window.location.reload();
};
